import AppLayoutContainer from './container';
import AppLayout from './Layout';

export { AppLayout };
export default AppLayoutContainer;
